module.exports = __webpack_public_path__ + "exo-latin-300italic.6ce1566735a3d3667090.eot";


//////////////////
// WEBPACK FOOTER
// /srv/prod/FitRadioAdmin2/node_modules/typeface-exo/files/exo-latin-300italic.eot
// module id = ../../../../typeface-exo/files/exo-latin-300italic.eot
// module chunks = styles